__turbopack_context__.v({
  "loader": "spinner-module__3kku6W__loader",
  "rotate": "spinner-module__3kku6W__rotate",
  "wrapper": "spinner-module__3kku6W__wrapper",
});
